import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { DocumentTypeSize } from '@/types'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}
interface DocumentTypeSizeItem {
  id: DocumentTypeSize
  name: string
}

const values: DocumentTypeSizeItem[] = [
  { id: DocumentTypeSize.A3, name: 'A3' },
  { id: DocumentTypeSize.A4, name: 'A4' },
  { id: DocumentTypeSize.A5, name: 'A5' },
  { id: DocumentTypeSize.A6, name: 'A6' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<DocumentTypeSizeItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
